module.exports = __webpack_public_path__ + "img/machine-background-video-badge.9a0a4560.jpg";